// extracted by mini-css-extract-plugin
export default {"button":"dq-z","reviewSort":"eq-z"};